import { render, staticRenderFns } from "./PaltaCheckout.vue?vue&type=template&id=d4aff00a&scoped=true&"
import script from "./PaltaCheckout.vue?vue&type=script&lang=js&"
export * from "./PaltaCheckout.vue?vue&type=script&lang=js&"
import style0 from "./PaltaCheckout.vue?vue&type=style&index=0&id=d4aff00a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4aff00a",
  null
  
)

export default component.exports